import {IItemContent} from "../../typescript-library";
import React, {Suspense} from "react";
import ReactDOM from "react-dom";
import {useTranslation} from "react-i18next";
import ErrorBoundary from "../utils/ErrorBoundary";
import {SwiperWithTitleAndItems} from "../organisms/crossSelling/SwiperBuilder";

const ProductSeriesPortal: React.FC<{element: HTMLElement, items: IItemContent[]}> = ({element, items}) => {
  const {t} = useTranslation();
  const parentName = element.dataset.name;
  const url = element.dataset.categoryUrl;

  return ReactDOM.createPortal(
    <ErrorBoundary fallback={null} occurrence="ProductSeriesPortal">
      <Suspense>
        <SwiperWithTitleAndItems
          title={t("product.discoverProductLine--name", {name: parentName})}
          items={items}
          link={
            url &&
            parentName && (
              <a href={url} className={"swiper-cross-selling__title"}>
                {t("product.showItemsFrom--name", {name: parentName})}
              </a>
            )
          }
          context={null}
        />
      </Suspense>
    </ErrorBoundary>,
    element,
  );
};

export default ProductSeriesPortal;
